import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import env from "env";
import { baseQueryCreator } from "redux/baseQuery";
import { Country } from "./type";

export interface CountryListRequest {
  pageSize: number;
  pageNumber: number;
  searchText?: string;
  region?: string;
}

export interface CityListRequest {
  pageSize: number;
  pageNumber: number;
  searchText?: string;
  region?: string;
}

export interface CountryListResponse {
  data: Country[];
  paging: {
    pageNumber: number;
    pageSize: number;
    totalRecords: number;
  };
  status: {
    code: string;
    message: string;
  };
}

const { countryService } = env.api.baseUrl;

const baseQuery = fetchBaseQuery({
  baseUrl: countryService,
  prepareHeaders: (headers, { getState }) => {
    const token = (getState() as any).auth.accessToken;
    if (token) {
      headers.set("Authorization", `Bearer ${token}`);
    }
    return headers;
  },
});

export const countryApi = createApi({
  reducerPath: "countryApi",
  baseQuery: baseQueryCreator(baseQuery),
  refetchOnMountOrArgChange: true,
  tagTypes: ["Country"],
  endpoints: (builder) => ({
    getCountriesList: builder.query<CountryListResponse, CountryListRequest>({
      query: ({ pageSize = 10, pageNumber = 1, searchText = "", region }) => {
        return {
          url: `/countries`,
          method: "GET",
          params: {
            pageSize,
            pageNumber,
            searchText,
            region,
          },
        };
      },
      providesTags: () => ["Country"],
    }),
  }),
});

export const { useGetCountriesListQuery } = countryApi;
